








































































































































































import { Vue, Component, Mixins } from "vue-property-decorator";

import MyList from "@/mixins/list";

import SelectStadium from "@/components/selectstadium.vue";

@Component({
  components: {
    SelectStadium
  }
})
export default class extends Mixins(MyList) {
  dispatchType: string = "stadiumcrm/loglist";

  columns: any[] = [
    { title: "编号", dataIndex: "id" },
    { title: "场馆名称", dataIndex: "stadium_name" },
    { title: "姓名", dataIndex: "name" },
    { title: "手机号", dataIndex: "mobile" },
    { title: "提醒时间", dataIndex: "created_time" },
    { title: "上/下班时间", scopedSlots: { customRender: "work_time" } },
    { title: "状态", scopedSlots: { customRender: "status" } },
    { title: "打卡时间", dataIndex: "updated_time" },
    { title: "打卡地点", dataIndex: "address" },
    { title: "人脸打卡", scopedSlots: { customRender: "phone" } }
  ];

  // 操作搜索栏的展开和折叠
  isFlag = false;


  mounted() {
    this.loadData();
  }
}
